/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingsForPromoSliderOnMapRequest,
  TGetNewbuildingsForPromoSliderOnMapModel,
  IMappers,
  TGetNewbuildingsForPromoSliderOnMapResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsForPromoSliderOnMapResponse } from '../../entities/get_newbuildings_for_map_promo_slider/GetNewbuildingsForPromoSliderOnMapResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsForPromoSliderOnMapModel(
  parameters: TGetNewbuildingsForPromoSliderOnMapRequest,
): TGetNewbuildingsForPromoSliderOnMapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-newbuildings-for-promo-slider-on-map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingsForPromoSliderOnMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingsForPromoSliderOnMapRequest;
}

export async function fetchGetNewbuildingsForPromoSliderOnMap<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsForPromoSliderOnMapOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsForPromoSliderOnMapResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsForPromoSliderOnMapModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingsForPromoSliderOnMapResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForPromoSliderOnMapResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsForPromoSliderOnMapResponse>;
}
